import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import cx from "classnames";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import {
  Button,
  Col,
  Container,
  Input,
  Row,
  TabContent,
  TabPane,
  Table
} from "reactstrap";
import moment from "moment";
import DatePicker from "react-date-picker";
import { uploadFile } from "react-s3";

import noTeammatesImg from "assets/images/team-challenges/no-teammates.png";
import Socket from "socket/socket";
import checkIcon from "assets/images/check-circle.png";
import fileIcon from "assets/images/file-icon.png";
import barImg from "assets/images/team-challenges/bar-graph.png";
import calcImg from "assets/images/team-challenges/calculator.png";
import calenderImg from "assets/images/team-challenges/calendar.png";
import competitiveImg from "assets/images/team-challenges/competitive.png";
import cooperativeImg from "assets/images/team-challenges/cooperative.png";
import fullTeamImg from "assets/images/team-challenges/full-team.png";
import targetGoalImg from "assets/images/team-challenges/goal.png";
import highestRed from "assets/images/team-challenges/highestRed.png";
import highestWhite from "assets/images/team-challenges/highestWhite.png";
import individualImg from "assets/images/team-challenges/individual.png";
import lowestRed from "assets/images/team-challenges/lowestRed.png";
import lowestWhite from "assets/images/team-challenges/lowestWhite.png";
import pigImg from "assets/images/team-challenges/pig.png";
import womenImg from "assets/images/team-challenges/women.png";
import dummyavatar from "assets/images/verboden/user.png";
import Alert from "components/shared/common/alert";
import {
  set_editChallenge,
  set_prefillFormState,
  set_prefilledFormObject,
  set_uploadedImgName,
  set_uploadedImgUrl
} from "redux/opt/action";
import { setIsLoading } from "redux/loader/action";

const CreateNewChallenge = (props) => {
  const dispatch = useDispatch();
  const [previewImage, setPreviewImage] = useState(false);
  const [currentActiveTab, setCurrentActiveTab] = useState("1");
  const [runValidations, setRunValidations] = useState(false);
  const [finishClick, setFinishClick] = useState(false);
  const [inputValues, setInputValues] = useState({
    challengeName: "",
    challengeType: "Competitive",
    challengeDiscription: "",
    goalType: "Cumulative",
    challengeUnit: "",
    targetGoal: null,
    end_on_goal: false,
    includeWeekends: false,
    displayType: "None",
    startDate: "",
    endDate: "",
    archived: false,
    positive: true
  });

  const config = {
    bucketName: "gameapart-assets",
    dirName: "challenges",
    region: "us-east-1",
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
  };

  const toggleArchiveChallenge = () => {
    setInputValues({ ...inputValues, archived: !inputValues.archived });
  };

  const handleCancel = () => {
    dispatch(set_prefilledFormObject({}));
    dispatch(set_prefillFormState(false));
    props.history.push("challenges-library");
  };

  useEffect(() => {
    if (props.prefillChallengeForm) {
      setInputValues({
        ...inputValues,
        includeWeekends: props.prefilledFormObject.includeWeekends || false,
        displayType: props.prefilledFormObject.displayType
          ? props.prefilledFormObject.displayType
          : "None",

        challengeName: props.prefilledFormObject.challengeName,
        challengeType: props.prefilledFormObject.challengeType,
        challengeDiscription: props.prefilledFormObject.challengeDiscription,
        goalType: props.prefilledFormObject.goalType,
        challengeUnit: props.prefilledFormObject.challengeUnit,
        // end_on_goal: props.prefilledFormObject.end_on_goal ,

        positive: props.prefilledFormObject.positive || true,
        targetGoal: props.prefilledFormObject.targetGoal,
        startDate: props.prefilledFormObject.startDate,
        end_on_goal: props.prefilledFormObject.end_on_goal || false,
        endDate: props.prefilledFormObject.endDate,
        archived: props.prefilledFormObject.archived
          ? props.prefilledFormObject.archived
          : false
      });
      !props.useTemplate &&
        dispatch(set_uploadedImgUrl(props.dataViewChallenge?.challenge_image));
    }
  }, [props.prefillChallengeForm]);

  const handleSubmitChallenge = () => {
    handleSubmitForm();
    let data = {
      action: "challenge-create",
      team_code: props.current_user?.team?.id,
      user_id: props.current_user?.userId,
      name: inputValues?.challengeName,
      type: inputValues?.challengeType,
      description: inputValues?.challengeDiscription,
      unit: inputValues?.challengeUnit,
      goal: parseInt(inputValues?.targetGoal),
      goal_type: inputValues?.goalType,
      start_date: inputValues?.startDate,
      end_date: inputValues?.endDate,
      end_on_goal: inputValues?.end_on_goal,
      show_data: inputValues?.displayType,
      positive: inputValues?.positive,
      weekends: inputValues?.includeWeekends,
      archived: false,
      challenge_image: props.uploadedImgUrl,
      participants: props.parcipantsUsernames
    };
    Socket.sendMessage(data);
    dispatch(set_editChallenge(false));
    if (
      inputValues.challengeName !== "" &&
      inputValues.challengeType !== "" &&
      inputValues.challengeDiscription !== "" &&
      inputValues.goalType !== "" &&
      inputValues.challengeUnit !== "" &&
      inputValues.end_on_goal
        ? inputValues.targetGoal !== null
        : true &&
          inputValues.includeWeekends !== "" &&
          inputValues.displayType !== "" &&
          inputValues.startDate !== "" &&
          inputValues.endDate !== "" &&
          inputValues.endDate &&
          inputValues.startDate
    ) {
      dispatch(setIsLoading(true));
      props.history.push("challenges-library");
    }
  };

  const handleUploadImage = (e) => {
    dispatch(setIsLoading(true));
    if (e.target.files.length > 0) {
      let file = e.target.files[0];
      let fileName = file.name.replace(/\.png$/, "");
      dispatch(set_uploadedImgName(fileName));

      uploadFile(file, config)
        .then((data) => {
          dispatch(set_uploadedImgUrl(data?.location));
          dispatch(setIsLoading(false));
        })
        .catch((err) => {
          Alert(400, "Error uploading profile image. Please try again.");
          dispatch(setIsLoading(false));
        });
    }
  };

  const tabToggler = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  const handleDropdownSelect = (value, type) => {
    setRunValidations(!runValidations);
    if (type === "challengeType") {
      setInputValues({ ...inputValues, [type]: value });
    }
    if (type === "goalType") {
      setInputValues({ ...inputValues, [type]: value });
    }
    if (type === "displayType") {
      setInputValues({ ...inputValues, [type]: value });
    }
    if (type === "includeWeekends") {
      setInputValues({ ...inputValues, [type]: value });
    }
  };

  const handleStartDateChange = (e) => {
    setInputValues({
      ...inputValues,
      startDate: moment(e).format("MM/DD/YYYY")
    });
  };

  const handleEndDateChange = (e) => {
    setInputValues({
      ...inputValues,
      endDate: moment(e).format("MM/DD/YYYY")
    });
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setInputValues({ ...inputValues, [name]: value });
  };
  const handleEditChallenge = () => {
    handleSubmitForm();

    let data = {
      action: "challenge-update",
      team_code: props.dataViewChallenge?.team_code,
      challenge_id: props.dataViewChallenge?.challenge_id,
      user_id: props.dataViewChallenge?.host_user_id,
      name: inputValues?.challengeName,
      type: inputValues?.challengeType,
      description: inputValues?.challengeDiscription,
      unit: inputValues?.challengeUnit,
      goal: parseInt(inputValues?.targetGoal),
      goal_type: inputValues?.goalType,
      start_date: inputValues?.startDate,
      end_date: inputValues?.endDate,
      positive: inputValues?.positive,
      end_on_goal: inputValues?.end_on_goal,
      show_data: inputValues?.displayType,
      weekends: inputValues?.includeWeekends,
      challenge_image: props.uploadedImgUrl,
      archived: inputValues?.archived,
      participants: props.parcipantsUsernames
    };

    Socket.sendMessage(data);
    dispatch(set_editChallenge(false));

    if (
      inputValues.challengeName !== "" &&
      inputValues.challengeType !== "" &&
      inputValues.challengeDiscription !== "" &&
      inputValues.goalType !== "" &&
      inputValues.challengeUnit !== "" &&
      inputValues.end_on_goal
        ? inputValues.targetGoal !== null
        : true &&
          inputValues.includeWeekends !== "" &&
          inputValues.displayType !== "" &&
          inputValues.startDate !== "" &&
          inputValues.endDate !== ""
    ) {
      props.history.push("challenges-library");
    }
  };
  const handleCheckboxChange = (e) => {
    setInputValues({
      ...inputValues,
      includeWeekends: !inputValues.includeWeekends
    });
  };

  const handleNextButtonv = () => {
    if (currentActiveTab === "1") {
      setCurrentActiveTab("2");
    } else {
      setCurrentActiveTab("3");
    }
  };

  const handleSubmitForm = () => {
    setCurrentActiveTab("1");
    setFinishClick(true);
  };

  return (
    <>
      <section className="create-new-ch">
        <Container>
          <Row>
            <Col md={7}>
              {
                <p>
                  {" "}
                  {props.editChallenge
                    ? "Edit Challenge"
                    : "Create New Challenge"}
                </p>
              }
              <h2>
                {currentActiveTab === "1"
                  ? "Step 1 - Build Challenge"
                  : currentActiveTab === "2"
                  ? "Step 2 - Challenge Settings"
                  : currentActiveTab === "3"
                  ? "Step 3 - Invite Participants"
                  : "Step 1 - Build Challenge"}
              </h2>
            </Col>
            <Col md={5} className="text-right">
              {!props.editChallenge ? (
                <div className="challange-content">
                  <div>
                    {props.editChallenge && (
                      <button
                        onClick={toggleArchiveChallenge}
                        className={cx("archive-btn mr-3", {
                          active: inputValues?.archived === true
                        })}
                      >
                        Archive
                      </button>
                    )}
                    <button onClick={handleCancel} className="cancel-btn mr-3">
                      {props.challengesParams?.create?.cancel
                        ? props.challengesParams?.create?.cancel
                        : "Cancel"}
                    </button>
                    {currentActiveTab === "3" && !props.editChallenge ? (
                      <button
                        onClick={handleSubmitChallenge}
                        className="next-btn"
                      >
                        Finish
                      </button>
                    ) : (
                      <button onClick={handleNextButtonv} className="next-btn">
                        Next
                      </button>
                    )}
                  </div>
                </div>
              ) : (
                <div className="challange-content">
                  <div>
                    <button
                      onClick={toggleArchiveChallenge}
                      className={cx("archive-btn mr-3", {
                        active: inputValues?.archived === true
                      })}
                    >
                      Archive
                    </button>
                    <button onClick={handleCancel} className="cancel-btn mr-3">
                      Cancel
                    </button>
                    {currentActiveTab === "3" ? (
                      <button
                        onClick={() => {
                          props.useTemplate
                            ? handleSubmitChallenge()
                            : handleEditChallenge();
                        }}
                        className="next-btn"
                      >
                        {props.challengesParams?.edit?.save
                          ? props.challengesParams?.edit?.save
                          : "Save"}
                      </button>
                    ) : (
                      <button onClick={handleNextButtonv} className="next-btn">
                        {props.challengesParams?.create?.next
                          ? props.challengesParams?.create?.next
                          : "Next"}
                      </button>
                    )}
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>

      <section className="create-new-ch-box">
        <h2 className="title">
          {props.editChallenge ? "Edit Challenge" : "Create New Challenge"}
        </h2>
        <p className="desc">
          Create and run team-wide challenges for more engagement and bonding.{" "}
        </p>
        <div className="challange-progress">
          <div className="col-12">
            <ul id="progressbar" className="text-center">
              <li
                className={cx("step0", {
                  active:
                    currentActiveTab === "1" ||
                    currentActiveTab === "2" ||
                    currentActiveTab === "3"
                })}
              ></li>
              <li
                className={cx("step0", {
                  active: currentActiveTab === "2" || currentActiveTab === "3"
                })}
              ></li>
              <li
                className={cx("step0", {
                  active: currentActiveTab === "3"
                })}
              ></li>
            </ul>
          </div>
        </div>
        <div className="challange-progress-text">
          <div className="box">
            <p
              onClick={() => {
                tabToggler("1");
              }}
              className="font-weight-bold"
            >
              Build Challenge
            </p>
          </div>
          <div className="box">
            <p
              onClick={() => {
                tabToggler("2");
              }}
              className="font-weight-bold"
            >
              Challenge Settings
            </p>
          </div>
          <div className="box">
            <p
              onClick={() => {
                tabToggler("3");
              }}
              className="font-weight-bold"
            >
              Invite Participants
            </p>
          </div>
        </div>
      </section>

      <Col md={12}>
        <TabContent activeTab={currentActiveTab}>
          <TabPane tabId="1">
            <Row>
              <Col sm={12}>
                <h4 className="ch-title">Challenge Details</h4>
                <div className="mb-4">
                  <Input
                    type="text"
                    name="challengeName"
                    placeholder={
                      props.challengesParams?.create?.name_hint
                        ? props.challengesParams?.create?.name_hint
                        : "Sample Challenge"
                    }
                    value={inputValues?.challengeName}
                    onChange={(e) => handleChange(e)}
                  />
                  {inputValues.challengeName === "" && finishClick && (
                    <p className="error">Please Enter Challenge Name</p>
                  )}
                </div>
                <div className="mb-4">
                  <Input
                    type="textarea"
                    name="challengeDiscription"
                    value={inputValues?.challengeDiscription}
                    className="resize-none"
                    placeholder={
                      props.challengesParams?.create?.description_hint
                        ? props.challengesParams?.create?.description_hint
                        : "Challenge Description"
                    }
                    rows="5"
                    onChange={(e) => handleChange(e)}
                  />
                  {inputValues?.challengeDiscription === "" && finishClick && (
                    <p className="error">Please Enter Challenge Description</p>
                  )}
                </div>
                <h4 className="ch-title" style={{ color: "#18154d" }}>
                  Challenge Dates
                </h4>
                <Row>
                  <Col md={6}>
                    <div className="">
                      <DatePicker
                        onChange={(e) => handleStartDateChange(e)}
                        format="MM-dd-yyyy"
                        name="myCustomName"
                        dayPlaceholder="dd"
                        monthPlaceholder="mm"
                        yearPlaceholder="yyyy"
                        value={inputValues?.startDate}
                      />
                      {(inputValues?.startDate === "" ||
                        !inputValues?.startDate) &&
                        finishClick && (
                          <p className="error">Please select start date</p>
                        )}
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="">
                      <DatePicker
                        format="MM-dd-yyyy"
                        name="myCustomName"
                        dayPlaceholder="dd"
                        monthPlaceholder="mm"
                        yearPlaceholder="yyyy"
                        onChange={(e) => handleEndDateChange(e)}
                        value={inputValues?.endDate}
                      />
                      {(inputValues?.endDate === "" || !inputValues?.endDate) &&
                        finishClick && (
                          <p className="error">Please select end date</p>
                        )}
                    </div>
                  </Col>
                  <div className="divider"></div>
                </Row>
                <div className="challenge-type">
                  <h2 className="ch-title">Challenge Type</h2>
                  <Row>
                    <Col md={6}>
                      <div
                        onClick={() =>
                          handleDropdownSelect("Competitive", "challengeType")
                        }
                        className={cx("challenge-type__box", {
                          active: inputValues?.challengeType === "Competitive"
                        })}
                      >
                        <img src={competitiveImg} alt="" />
                        <h5>Competitive</h5>
                        <p>
                          Teammates’ participation is compared individually.{" "}
                        </p>
                        {inputValues?.challengeType === "Competitive" && (
                          <p className="selected">Selected</p>
                        )}
                      </div>
                    </Col>
                    <Col md={6}>
                      <div
                        onClick={() =>
                          handleDropdownSelect("Cooperative", "challengeType")
                        }
                        className={cx("challenge-type__box", {
                          active: inputValues?.challengeType === "Cooperative"
                        })}
                      >
                        <img src={cooperativeImg} alt="" />
                        <h5>Cooperative</h5>
                        <p>All teammates contribute toward a common goal.</p>
                        {inputValues?.challengeType === "Cooperative" && (
                          <p className="selected">Selected</p>
                        )}
                      </div>
                    </Col>
                    <div className="divider"></div>
                  </Row>
                </div>

                <h4 className="ch-title mb-2">Challenge Unit</h4>
                <p className="mb-4">
                  The main unit tracked and entered by teammates.
                </p>
                <Row>
                  <Col md={6}>
                    <div className="">
                      <Input
                        value={inputValues?.challengeUnit}
                        type="text"
                        name="challengeUnit"
                        placeholder={
                          props.challengesParams?.create?.unit_hint
                            ? props.challengesParams?.create?.unit_hint
                            : "Challenge Unit"
                        }
                        onChange={(e) => handleChange(e)}
                      />
                      {inputValues?.challengeUnit === "" && finishClick && (
                        <p className="error">Please Enter Challenge Unit</p>
                      )}
                    </div>
                  </Col>
                  <Col
                    md={6}
                    className="d-flex align-items-center checkbox-filled"
                  >
                    <div>
                      <label className="mb-0">Example: 35 Pushups</label>
                    </div>
                  </Col>
                  <div className="divider"></div>
                </Row>
                <h4 className="ch-title mb-2">Challenge Measurement</h4>
                <p className="mb-4">Define how your unit should be measured.</p>
                <div>
                  <div className="challenge-measurement">
                    <div className="challenge-measurement__box first">
                      <div
                        onClick={() => {
                          setInputValues({ ...inputValues, positive: true });
                        }}
                        className={cx("box1", {
                          active: inputValues?.positive === true
                        })}
                      >
                        <img
                          src={
                            inputValues?.positive === true
                              ? highestWhite
                              : highestRed
                          }
                          alt=""
                        />
                        <h6>Highest</h6>
                        {inputValues?.positive === true && <p>Selected</p>}
                      </div>
                      <div
                        onClick={() => {
                          setInputValues({ ...inputValues, positive: false });
                        }}
                        className={cx("box1", {
                          active: inputValues?.positive === false
                        })}
                      >
                        <img
                          src={
                            inputValues?.positive === false
                              ? lowestWhite
                              : lowestRed
                          }
                          alt=""
                        />
                        <h6 className="lowest">Lowest</h6>
                        {inputValues?.positive === false && <p>Selected</p>}
                      </div>
                    </div>
                    <div
                      onClick={() =>
                        handleDropdownSelect("Cumulative", "goalType")
                      }
                      className={cx("challenge-measurement__box", {
                        active: inputValues?.goalType === "Cumulative"
                      })}
                    >
                      <div className="ttt">
                        <img src={pigImg} className="img" alt="" />
                        <p
                          className={cx("heading", {
                            active: inputValues?.goalType === "Cumulative"
                          })}
                        >
                          Total
                        </p>
                        <p
                          className={cx("desc", {
                            active: inputValues?.goalType === "Cumulative"
                          })}
                        >
                          All participation is combined into final amount.
                        </p>
                        {inputValues?.goalType === "Cumulative" && (
                          <p className="selected">Selected</p>
                        )}
                      </div>
                    </div>
                    <div
                      onClick={() =>
                        handleDropdownSelect("Average", "goalType")
                      }
                      className={cx("challenge-measurement__box", {
                        active: inputValues?.goalType === "Average"
                      })}
                    >
                      <div className="ttt">
                        <img src={barImg} className="img" alt="" />
                        <p
                          className={cx("heading", {
                            active: inputValues?.goalType === "Average"
                          })}
                        >
                          Average
                        </p>
                        <p
                          className={cx("desc", {
                            active: inputValues?.goalType === "Average"
                          })}
                        >
                          All participation is averaged into one amount.
                        </p>
                        {inputValues?.goalType === "Average" && (
                          <p className="selected">Selected</p>
                        )}
                      </div>
                    </div>
                    <div
                      onClick={() =>
                        handleDropdownSelect("Improvement", "goalType")
                      }
                      className={cx("challenge-measurement__box", {
                        active: inputValues?.goalType === "Improvement"
                      })}
                    >
                      <div className="ttt">
                        <img src={calcImg} className="img" alt="" />
                        <p
                          className={cx("heading", {
                            active: inputValues?.goalType === "Improvement"
                          })}
                        >
                          Change
                        </p>
                        <p
                          className={cx("desc", {
                            active: inputValues?.goalType === "Improvement"
                          })}
                        >
                          Compares first entry to highest/lowest amount. (%)
                        </p>
                        {inputValues?.goalType === "Improvement" && (
                          <p className="selected">Selected</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="divider2"></div>
                </div>

                <div className="challenge-type">
                  <h2 className="ch-title mb-2">Challenge Completion.</h2>
                  <p className="mb-4">
                    Define what succesfully completing this challenge looks
                    like.
                  </p>
                  <Row>
                    <Col md={6}>
                      <div
                        onClick={() => {
                          setInputValues({
                            ...inputValues,
                            end_on_goal: false
                          });
                        }}
                        className={cx("challenge-type__box", {
                          active: inputValues?.end_on_goal === false
                        })}
                      >
                        <img src={calenderImg} alt="" />
                        <h5>End at Selected Date</h5>
                        <p>Participation continues until end date </p>
                        {inputValues?.end_on_goal === false && (
                          <p className="selected">Selected</p>
                        )}
                      </div>
                    </Col>
                    <Col md={6}>
                      <div
                        onClick={() => {
                          setInputValues({ ...inputValues, end_on_goal: true });
                        }}
                        className={cx("challenge-type__box", {
                          active: inputValues?.end_on_goal === true
                        })}
                      >
                        <img src={targetGoalImg} alt="" />
                        <h5>End at Target Goal</h5>
                        <p>Challenge stops once goal is met. </p>
                        {inputValues?.end_on_goal === true && (
                          <p className="selected">Selected</p>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
                <h2
                  className="ch-title"
                  style={{
                    color: "#18154D",
                    marginTop: "28px",
                    marginBottom: "8px"
                  }}
                >
                  Set Target Goal
                </h2>
                <Row>
                  <Col md={6}>
                    <div className="">
                      <Input
                        value={inputValues?.targetGoal}
                        type="number"
                        name="targetGoal"
                        placeholder={
                          inputValues?.goalType === "Cumulative"
                            ? "Add Goal (Total)"
                            : inputValues?.goalType === "Average"
                            ? "Add Goal (Average)"
                            : inputValues?.goalType === "Improvement"
                            ? "Add Goal (Change %)"
                            : "Add Goal"
                        }
                        onChange={(e) => handleChange(e)}
                      />
                      {inputValues?.targetGoal === null &&
                        finishClick &&
                        inputValues?.end_on_goal && (
                          <p className="error">Please Enter Target Goal</p>
                        )}
                    </div>
                  </Col>
                  <Col
                    md={6}
                    className="d-flex align-items-center checkbox-filled"
                  >
                    <div>
                      <label className="mb-0">
                        Example: (Goal)% Increase Change
                      </label>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h3 className="mb-0">Challenge Participants</h3>
              <Button
                className="invite-teammates-btn"
                onClick={() => props.setModal(true)}
              >
                {props.editChallenge ? "Edit Teammates" : "Invite Teammates"}
              </Button>
            </div>

            {props.socketReducer?.invitedPlayers.length > 0 ? (
              <Table
                bordered
                responsive
                className="ch-part-table"
                cellPadding="0"
                cellSpacing="0"
              >
                <thead>
                  <tr>
                    <th>Teammate</th>
                    <th>Last Active</th>
                    <th>Entries</th>
                    <th>Progress</th>
                  </tr>
                </thead>
                <tbody>
                  {props.socketReducer?.invitedPlayers &&
                    props.socketReducer?.invitedPlayers.map((item) => {
                      return (
                        <tr>
                          <td>
                            <div className="teammate">
                              <img
                                src={item.picture ? item.picture : dummyavatar}
                                alt=""
                              />
                              <p className="mb-0">{item.name}</p>
                            </div>
                          </td>
                          <td>
                            {" "}
                            {item?.latest_entry_ts === 0
                              ? "None"
                              : moment(item?.latest_entry_ts * 1000).format(
                                  "MM/DD/YYYY"
                                )}
                          </td>
                          <td>{item?.entries ? item?.entries : "0"}</td>
                          <td>
                            {item.data ? item.data : 0} (
                            {inputValues?.challengeUnit})
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            ) : (
              <>
                <div className="no-tm-found">
                  <img src={noTeammatesImg} alt="" />
                  <p className="text">
                    No teammates to display. Add teammates to participate in
                    your challenge.
                  </p>
                </div>
              </>
            )}
          </TabPane>
          <TabPane tabId="2">
            <div className="team-display">
              <h2 className="ch-title">Team Display</h2>
              <Row>
                <Col md={4}>
                  <div
                    onClick={() => handleDropdownSelect("None", "displayType")}
                    className={cx("team-display__box", {
                      active: inputValues?.displayType === "None"
                    })}
                  >
                    <img src={womenImg} alt="" />
                    <h5>None</h5>
                    <p>No leaderboard shown to teammates. </p>
                    {inputValues?.displayType === "None" && (
                      <p className="selected">Selected</p>
                    )}
                  </div>
                </Col>
                <Col md={4}>
                  <div
                    onClick={() => handleDropdownSelect("Own", "displayType")}
                    className={cx("team-display__box", {
                      active: inputValues?.displayType === "Own"
                    })}
                  >
                    <img src={individualImg} alt="" />
                    <h5>Individual Leaderboard</h5>
                    <p>Teammates can only see their own progress. </p>
                    {inputValues?.displayType === "Own" && (
                      <p className="selected">Selected</p>
                    )}
                  </div>
                </Col>
                <Col md={4}>
                  <div
                    onClick={() => handleDropdownSelect("Full", "displayType")}
                    className={cx("team-display__box", {
                      active: inputValues?.displayType === "Full"
                    })}
                  >
                    <img src={fullTeamImg} alt="" />
                    <h5>Full Team Leaderboard</h5>
                    <p>All teammates can see everyone’s progress.</p>
                    {inputValues?.displayType === "Full" && (
                      <p className="selected">Selected</p>
                    )}
                  </div>
                </Col>
              </Row>
              <div className="divider2"></div>
              <div className="challenge-sampling">
                <h2 className="ch-title">Challenge Sampling Settings</h2>
                <div
                  className="d-flex align-items-center"
                  style={{ marginLeft: "5px" }}
                >
                  <Input
                    onClick={(e) => handleCheckboxChange(e)}
                    type="checkbox"
                    name="check"
                    id="sampling"
                  />
                  <label className="mb-0 label" htmlFor="sampling">
                    Include Weekends?
                  </label>
                </div>
              </div>
              <div className="divider2"></div>
              <div className="mb-3 add-ch-image">
                <div className="add-ch-image__flex">
                  <label htmlFor="">Add Challenge Image</label>
                  <div className="d-flex align-items-center">
                    <p
                      onClick={() => {
                        setPreviewImage(!previewImage);
                      }}
                      className="prev-txt"
                    >
                      Preview Image
                    </p>
                    <p onClick={props.handleRemoveImage} className="rem-txt">
                      Remove Image
                    </p>
                  </div>
                </div>
                <div
                  className={cx("upload-section", {
                    uploadedDiv:
                      props.uploadedImgUrl !== "" &&
                      props.uploadedImgUrl !== undefined &&
                      props.uploadedImgUrl !== null &&
                      previewImage,
                    uploadedDivGreenBorder:
                      props.uploadedImgUrl !== "" &&
                      props.uploadedImgUrl !== undefined &&
                      props.uploadedImgUrl !== null
                  })}
                >
                  <img
                    alt=""
                    src={
                      props.uploadedImgUrl !== "" &&
                      props.uploadedImgUrl !== undefined &&
                      props.uploadedImgUrl !== null &&
                      previewImage
                        ? props.uploadedImgUrl
                        : fileIcon
                    }
                  />
                  <div className="d-flex align-items-center">
                    <img src={checkIcon} className="check-icon mr-2" alt="" />
                    <label
                      className={cx("label", {
                        uploadedLable:
                          props.uploadedImgUrl !== "" &&
                          props.uploadedImgUrl !== undefined
                      })}
                      htmlFor=""
                    >
                      {props.uploadedImgName !== ""
                        ? props.uploadedImgName
                        : "Add Challenge Image"}
                    </label>
                  </div>
                  <Input
                    type="file"
                    name="name"
                    className="upload-file"
                    accept="image/png, image/jpeg"
                    onChange={(e) => handleUploadImage(e)}
                  />
                </div>
              </div>
            </div>
          </TabPane>
        </TabContent>
      </Col>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
  socketReducer: state.socketReducer
});

export default connect(mapStateToProps, null)(CreateNewChallenge);
